/**
 *
 * Asynchronously loads the component for ModalPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ModalPage = lazyLoad(
  () => import('./index'),
  module => module.ModalPage,
);
